<template>
  <el-form
    v-if="isLoaded"
    :model="setDateForm"
    ref="setDateForm"
    label-position="top"
  >
    <el-row>
      <h3 class="date-help-text">
        {{ $t('re-conciliation.set-date.message') }}
      </h3>
      <el-col
        :lg="{span: 11}"
      >
        <el-form-item
          :label="$t('re-conciliation.set-date.start-date')"
          prop="startDate"
        >
          <el-date-picker
            v-model="setDateForm.startDate"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="date"
            :picker-options="getPickerOptions"
          />
        </el-form-item>
      </el-col>
      <el-col
        :lg="{span:11, offset:2}"
      >
        <el-form-item
          :label="$t('re-conciliation.set-date.end-date')"
          prop="endDate"
        >
          <el-date-picker
            v-model="setDateForm.endDate"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="date"
            :picker-options="getPickerOptions"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item>
      <el-row class="mt-20 mb-20">
        <el-col :span="11">
          <el-button
            type="cancel"
            class="cancel-button"
            @click="resetForm"
          >
            {{ $t('form.reset') }}
          </el-button>
        </el-col>
        <el-col
          :offset="2"
          :span="11"
        >
          <el-button
            type="primary"
            class="primary-button"
            @click="submitForm('setDateForm')"
          >
            {{ (poolingStrategy === 'simple') ? $t('form.confirm') : $t('form.next') }}
          </el-button>
        </el-col>
      </el-row>
    </el-form-item>
    <confirm-team-reconciliation
      :visible.sync="confirmTeamReconciliationVisible"
      :team-id="$route.params.teamId"
      :dates="selectedDates"
    />
  </el-form>
</template>

<script>
import ConfirmTeamReconciliation from '../Components/ConfirmTeamReconciliation';
import { Auth } from '@aws-amplify/auth'

export default {
  name: 'SetDate',
  components: {
    ConfirmTeamReconciliation
  },
  data: () => ({
    isLoaded: false,
    teams: [],
    setDateForm: {
      startDate: '',
      endDate: ''
    },
    confirmTeamReconciliationVisible: false
  }),
  created () {
    Auth.currentAuthenticatedUser().then((user) => {
      this.$adminApi.get(`/api/v1/entities/teams/representatives/${user.attributes.sub}`).then((teams) => {
        this.teams = teams.data;
        this.isLoaded = true;
      });
    });
  },
  computed: {
    poolingStrategy () {
      const team = this.teams.find((el) => {
        return el.id === this.$route.params.teamId;
      });
      return team.poolingStrategy || 'complex';
    },
    selectedDates: {
      get: function () {
        return {
          startDate: this.setDateForm.startDate,
          endDate: this.setDateForm.endDate
        };
      }
    },
    getPickerOptions: function () {
      return {
        shortcuts: [{
          text: this.$t('menu.reports.datepicker.last-week'),
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('menu.reports.datepicker.last-month'),
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('menu.reports.datepicker.last-year'),
          onClick (picker) {
            const end = new Date();
            const start = new Date(new Date().getFullYear() - 1, new Date().getMonth(), new Date().getDate());
            picker.$emit('pick', [start, end]);
          }
        }]
      };
    }
  },
  methods: {
    submitForm (formName = '') {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let routeParams = {
            teamId: this.$route.params.teamId
          };
          if (this.setDateForm.startDate) {
            Object.assign(routeParams, { startDate: this.setDateForm.startDate });
          }
          if (this.setDateForm.endDate) {
            Object.assign(routeParams, { endDate: this.setDateForm.endDate });
          }
          if (this.poolingStrategy === 'simple') {
            this.confirmTeamReconciliationVisible = true;
          } else {
            this.$router.push({
              name: 'SetAmount',
              params: routeParams
            });
          }
        } else {
          return false;
        }
      });
    },
    resetForm () {
      this.$refs['setDateForm'].resetFields();
    }
  }
};
</script>

<style lang="scss" scoped>
.date-help-text {
  font-size: 16px;
  color: #000000;
  font-family: "Raleway Regular", serif;
}
</style>
